import React from 'react'
import { Ubicacion } from '../Ubicacion'

const Ubi = () => {
    return (
        <>
            <Ubicacion
                nivel={3}
                descripcion='Ubicaciones'
                comboDescripcion='Región:'
                comboNivel={2}
            />
        </>
    )
}

export { Ubi }